import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesRepoSettingsPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./settings'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesRepoSettingsPageLoadable;
